// extracted by mini-css-extract-plugin
export default {"body":"Body_body__t4Y+Q","slide":"Body_slide__l80NT","active":"Body_active__vW+YC"};